export enum AuthErrors {
  INVALID_GRANT = 'invalid_grant',
  UNAUTHORIZED = 'unauthorized'
}
